import Cryptoicon from 'vue-cryptoicon';
import icons from 'vue-cryptoicon/src/icons';
Cryptoicon.add(icons);

export default Cryptoicon




// WEBPACK FOOTER //
// ./src/plugins/cryptoicons.js